module.exports = __webpack_public_path__ + "img/no-permission.20ec7818.png";